import { NgFor } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-socials',
  imports: [NgFor],
  templateUrl: './socials.component.html',
  styleUrl: './socials.component.scss',
})
export class SocialsComponent {
  socials = [
    {
      iconUrl: 'assets/svgs/icons/social-media/twitter-black.svg',
      name: 'X',
      link: '',
    },
    {
      iconUrl: 'assets/svgs/icons/social-media/facebook-black.svg',
      name: 'Facebook',
      link: 'https://www.facebook.com/profile.php?id=61589447625453',
    },
    {
      iconUrl: 'assets/svgs/icons/social-media/instagram-black.svg',
      name: 'Instagram',
      link: '',
    },
    {
      iconUrl: 'assets/svgs/icons/social-media/linkedIn-black.svg',
      name: 'LinkedIn',
      link: 'https://www.linkedin.com/company/atrizult-practical-consulting',
    },
  ];
}
